import { Box, Typography } from "@mui/material";

interface IProps {
  height: any;
  message?: string;
}

const EmptyTableData = ({ height, message = "No data" }: IProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: { height },
      }}
    >
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

export default EmptyTableData;
